module.exports = __webpack_public_path__ + "img/martindale.7f439711.png";